// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center[data-v-fae5bece] {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-left: -150px;\r\n  margin-top: -50px;\n}\r\n", ""]);
// Exports
module.exports = exports;
